var map = {
	"./arrow-down-grey.svg": "5a8e",
	"./arrow-down.svg": "dc17",
	"./arrow-right-grey.svg": "69f35",
	"./arrow-right.svg": "1378",
	"./cog.svg": "f176",
	"./double-arrow-down.svg": "032e",
	"./double-arrow-up.svg": "881f",
	"./edit.svg": "13e1",
	"./folder.svg": "6d91",
	"./graph.svg": "13b2",
	"./info.svg": "7a66",
	"./menu.svg": "4994",
	"./temperature.svg": "9244"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f05";